/*
 Dependencies
 */

import {Module} from "wrapper6";
import {debounce} from "./../_utils";

var $ = jQuery;

export default class NewsletterModule extends Module {

    boot() {
        if ($('.newsletter_overlay').length === 0) {
            return false;
        }
    }

    ready(app) {
        var _ = this;

        var modal = document.getElementById('newsletter_overlay');
        $('.newsletter_trigger_btn').on('click', function(event) {
            event.preventDefault();
            $('.newsletter_overlay').addClass('newsletter_open');
            $('.newsletter_dialog').addClass('newsletter_open');
        });

        $('.newsletter_trigger .close_trigger').click(function () {
            $('.newsletter_trigger').hide();
            var cookie = 'fyer_hide_morningcatch=true; path=/';
            var d = new Date();
            d.setTime(d.getTime() + (3600 * 1000 * 24 * 60));
            cookie += ";expires=" + d.toUTCString();
            document.cookie = cookie;
        });

        $(document).click(function (event) {
            if (event.target === modal) {
                $('.newsletter_overlay').removeClass('newsletter_open');
                $('.newsletter_dialog').removeClass('newsletter_open');
            }
        });

        $('.newsletter_dialog .close').click(function () {
            $('.newsletter_overlay').removeClass('newsletter_open');
            $('.newsletter_dialog').removeClass('newsletter_open');
        });

        $('#newsletter_signup_form').submit(function(event) {
            event.preventDefault();

            jQuery('#message').empty();
            $('.loader_overlay').addClass('is-loading');

            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                data: $('#newsletter_signup_form').serialize()
            }).done(function(response) {
                $('.loader_overlay').removeClass('is-loading');
                $('#message').append('<p>' + response.data + '</p>');

                if (response.success) {
                    $('#message').removeClass('error');
                    if (response.data !== '') {
                        $('#message').addClass('success');
                    }
                } else {
                    $('#message').removeClass('success');
                    $('#message').addClass('error');
                }
            });
        });

        var cookie = this.getCookie('fyer_hide_morningcatch');
        if (cookie !== 'true') {
            $('.newsletter_trigger').show();
        }
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}